<template>
    <BaseButton
        v-if="showButton"
        class="!fixed bottom-10 end-5 !rounded-full !p-3 text-xs shadow transition duration-150 ease-in-out outline-none ring-0
                hover:bg-primary-600 hover:text-white
                focus:bg-primary-600 focus:text-white
                active:bg-primary-600 active:text-white"
        @click="backToTop">
        <Icon
            name="heroicons:arrow-small-up"
            class="h-5 w-5" />
    </BaseButton>
</template>

<script setup>

const showButton = ref(false)

function checkVisibility() {
    showButton.value = document.getElementById('page-container').scrollTop > 20
}
function backToTop() {
    document.getElementById('page-container').scrollTo({ top: 0, behavior: "smooth" })
}

onMounted(() => {
    document.getElementById('page-container').addEventListener("scroll", checkVisibility)
})

onUnmounted(() => {
    document.getElementById('page-container').removeEventListener("scroll", checkVisibility)
})
</script>